import {useForm} from "react-hook-form";
import PaymentTypeSwitch from "./Components/PaymentTypeSwitch";
import {ONE_TIME, RECURRING} from "./Constants/PaymentTypes";
import {useFetchMethods} from "./Hooks/useFetchMethods";
import {useState} from "react";
import PaymentMethodSwitch from "./Components/PaymentMethodSwitch";
import TextInput from "./Components/TextInput";
import {postPaymentRequest} from "./Functions/ServerFunctions";
import i18n from "./i18n";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import {useEmailValidation} from "./Hooks/useEmailValidation";
import {useAmountValidation} from "./Hooks/useAmountValidation";
import {useTranslation} from "react-i18next";
import NumberWithCurrencyInput from "./Components/NumberWithCurrencyInput";
import {useFormIsValid} from "./Hooks/useFormIsValid";
import block from "bem-css-modules";
import ProgressBar from "./Components/ProgressBar/ProgressBar";

import s from './App.module.scss';
import {useDataFromHash} from "./Hooks/useDataFromHash";

const b = block(s);

// eslint-disable-next-line
const initI18n = i18n;

function App() {
    const {t} = useTranslation('common');

    const {recurring} = useDataFromHash();
    const [paymentType, setPaymentType] = useState(recurring ? RECURRING : ONE_TIME);
    const loading = useFetchMethods();
    const emailValidation = useEmailValidation();
    const amountValidation = useAmountValidation();
    const {control, handleSubmit, watch, formState: {isValid}} = useForm({
            defaultValues: {
                paymentType: recurring ? RECURRING : ONE_TIME,
            },
            mode: 'onChange',
            resolver: yupResolver(
                Yup.object({
                    email: emailValidation.required(t('errors.required')),
                    amount: amountValidation.required(t('errors.required'))
                })
            )
        }
    );
    const watchPaymentMethod = watch("paymentMethod", 0);
    const {submitEnabled, setSubmitEnabled} = useFormIsValid(isValid);

    if (loading) {
        return <div><ProgressBar size={90}/></div>
    }

    const onSubmit = data => {
        setSubmitEnabled(false);
        postPaymentRequest(data)
            .then(response => {
                setSubmitEnabled(true);
                window.open(response.url, "_self")
            })
            .catch(error => console.error(error))
    }
    const onChangePaymentType = type => setPaymentType(type);

    return (
        <div className={b()}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={b('person')}>
                    <TextInput type='name' control={control} name='name' className={b('data-field')}/>
                    <TextInput type='email' control={control} name='email' className={b('data-field')}/>
                </div>
                <TextInput type='purpose' control={control} name='purpose'/>
                <NumberWithCurrencyInput control={control} name='amount' watchPaymentMethod={watchPaymentMethod}/>
                <PaymentTypeSwitch control={control} name='paymentType' onChangePaymentType={onChangePaymentType}/>
                <PaymentMethodSwitch control={control} name='paymentMethod' paymentType={paymentType}/>
                <div className={b('buttons')}>
                    <button type="submit" className={b('donate-button')}
                            disabled={!submitEnabled}>{t('donate')}</button>

                </div>
            </form>
        </div>
    );
}

export default App;
